import { useCallback, useEffect, useState } from "react"

import { getDistribuitorOrdersSummary } from "helpers/backend_helper"

/**
 * Cifras de la pestaña «Pedidos». Un único endpoint las trae todas, así que la
 * pestaña no encadena peticiones.
 *
 * La carga se dispara la primera vez que se abre la pestaña, no al montar la
 * pantalla: la mayoría de las visitas se quedan en «General».
 */
export default function useResumenPedidos(estaVisible) {
  const [datos, setDatos] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [pedida, setPedida] = useState(false)

  const cargar = useCallback(async () => {
    setIsLoading(true)
    try {
      // ApiSuccessResponse envuelve la carga útil en `data`, al contrario que
      // los endpoints vecinos del dashboard, que devuelven el objeto plano.
      const respuesta = await getDistribuitorOrdersSummary({})
      setDatos(respuesta?.data || null)
    } catch (error) {
      // api_helper ya notifica el error
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!estaVisible || pedida) return
    setPedida(true)
    cargar()
  }, [estaVisible, pedida, cargar])

  return { state: { datos, isLoading }, events: { onRecargar: cargar } }
}
